import { render } from "./file-icon.vue.js?vue&type=template&id=29e85ef3!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./file-icon.vue?vue&type=template&id=29e85ef3"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__